<template>
    <div class="card" v-if="loaded">
        <ProfilItem
            v-model:nom="form.nom"
            v-model:prenom="form.prenom"
            v-model:gender="form.gender"
            v-model:email="form.email"
            v-model:telephone="form.telephone"
            v-model:adresse="form.adresse"
            v-model:cp="form.cp"
            v-model:ville="form.ville"
            v-model:uuid="form.uuid"
            ref="profilItem"
            @save="handleUpdateUser()"
        />
        <SecurityItem :userUuid="form.uuid"/>
        <QuittanceItem
            v-model:uuid="form.uuid"
            v-model:defaultSendQuittanceEmail="form.defaultSendQuittanceEmail"
            v-model:sendCopyEmail="form.sendCopyEmail"
        />
    </div>
    <SpinnerLoader v-else></SpinnerLoader>
</template>

<script>

import { ref, inject, onMounted, computed} from 'vue'
import ProfilItem from './../components/profil/ProfilItem';
import SecurityItem from './../components/profil/SecurityItem';
import QuittanceItem from './../components/profil/QuittanceItem';
import SpinnerLoader from './../components/loader/SpinnerLoader';
import { useStore } from 'vuex'

export default {
    components: {
        ProfilItem,
        SecurityItem,
        SpinnerLoader,
        QuittanceItem
    },

    setup() {
        const store = useStore();
        const genderOptions = computed(() => store.getters['getGenderOptions']);

        const loaded = ref(false);
        const form = ref({
            nom: '',
            prenom: '',
            email: '',
            gender: {id: 'Male', libelle: 'M.'},
            telephone: '',
            adresse: '',
            cp: '',
            ville: '',
            uuid: '',
            defaultSendQuittanceEmail: 0,
            sendCopyEmail: 0
        });

        onMounted(async () => {
            const api = inject('api');
            const result = await api.user.getCurrentUser();

            form.value.nom = result.nom
            form.value.prenom = result.prenom
            form.value.gender = genderOptions.value.find(g => g.id === result.gender)
            form.value.email = result.email
            form.value.telephone = result.telephone
            form.value.adresse = result.adresse
            form.value.cp = result.cp
            form.value.ville = result.ville
            form.value.uuid = result.uuid
            form.value.defaultSendQuittanceEmail = result.settings.default_send_quittance_email ? 1 : 0
            form.value.sendCopyEmail = result.settings.send_copy_email ? 1 : 0

            loaded.value = true;
        });

        return {form, loaded}
    },

    methods: {
        async handleUpdateUser() {
            this.$refs.profilItem.activateLoader();

            await this.$api.user.updateUser(this.form.uuid, {
                gender: this.form.gender.id,
                nom: this.form.nom,
                prenom: this.form.prenom,
                telephone: this.form.telephone,
                adresse: this.form.adresse,
                cp: this.form.cp,
                ville: this.form.ville,
            })
            .then(() => {
                this.$toast({title: 'Succès', description: "L'utilisateur à bien été enregistré."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            await this.$api.user.updateSettings('default_send_quittance_email', this.form.defaultSendQuittanceEmail === 1)
            await this.$api.user.updateSettings('send_copy_email', this.form.sendCopyEmail === 1)

            this.$refs.profilItem.deactivateLoader();
        },
    }
};
</script>